/*
 * kp-variantenwahl.js  –  KreativPünktchen
 * Zieht beim Umschalten einer Variantenzeile die übrigen Zeilen automatisch mit,
 * wenn die entstehende Kombination nicht existiert.
 * Beispiel: "Holzstempel / ohne Stempelkissen" -> Klick "Edy pastell grün"
 *           -> Abdruckfarbe springt auf "schwarz", Preis und Knopf aktualisieren sich.
 * Greift nur ein, wenn die Kombination sonst gar nicht kaufbar wäre.
 * Ändert nichts an Produkten, Preisen, Varianten oder deren Reihenfolge.
 *
 * Wichtig: Das Theme ersetzt die Auswahl nach jedem Klick komplett. Deshalb haelt
 * dieses Skript KEINE Referenz auf das Auswahl-Element, sondern sucht es bei jedem
 * Klick neu ueber e.target.closest(). Sonst wirkt nur der erste Klick.
 */
(function () {
  'use strict';

  var PICKER = 'variant-selects, variant-radios';
  var data = {};   // handle -> { ready: bool, variants: array|null }

  function handleOf(picker) {
    return (picker && picker.dataset && picker.dataset.productHandle) ||
      (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1] || null;
  }

  function prefetch(handle) {
    if (!handle || data[handle]) return;
    data[handle] = { ready: false, variants: null };
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        // /products/<handle>.js liefert hoechstens 250 Varianten - ohne Hinweis auf
        // die Abschneidung. Genau 250 heisst: Liste womoeglich unvollstaendig, dann
        // NICHT eingreifen, sonst gilt eine vorhandene Kombination als "gibt es nicht".
        // Betrifft im Shop nur HS004, PR006 und HS198 - die haben keine toten Klicks.
        if (p && p.variants && p.variants.length < 250) data[handle].variants = p.variants;
        data[handle].ready = true;
      })
      .catch(function () { data[handle].ready = true; });
  }

  function groups(picker) {
    var out = [];
    picker.querySelectorAll('fieldset').forEach(function (fs) {
      var ins = [].slice.call(fs.querySelectorAll('input[type="radio"]'));
      if (ins.length) out.push({ type: 'radio', inputs: ins });
    });
    if (!out.length) {
      picker.querySelectorAll('select').forEach(function (s) {
        out.push({ type: 'select', el: s });
      });
    }
    return out;
  }

  function current(g) {
    return g.map(function (grp) {
      if (grp.type === 'select') return grp.el.value;
      var c = grp.inputs.filter(function (i) { return i.checked; })[0];
      return c ? c.value : null;
    });
  }

  function opts(v) { return [v.option1, v.option2, v.option3]; }

  function apply(grp, value) {
    if (grp.type === 'select') { grp.el.value = value; return; }
    grp.inputs.forEach(function (i) { i.checked = (i.value === value); });
  }

  // Capture-Phase: wir korrigieren, BEVOR das Theme die Auswahl auswertet.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var picker = t.closest(PICKER);
    if (!picker) return;

    var handle = handleOf(picker);
    prefetch(handle);
    var d = data[handle];
    if (!d || !d.ready || !d.variants) return;   // noch nicht da oder bewusst aus
    var variants = d.variants;

    var g = groups(picker), idx = -1;
    g.forEach(function (grp, i) {
      if (grp.type === 'select' ? grp.el === t : grp.inputs.indexOf(t) > -1) idx = i;
    });
    if (idx < 0) return;

    var sel = current(g);
    var passt = variants.some(function (v) {
      return sel.every(function (val, i) { return opts(v)[i] === val; });
    });
    if (passt) return;                       // Kombination gibt es -> nichts tun

    var wanted = sel[idx];
    var cands = variants.filter(function (v) { return opts(v)[idx] === wanted; });
    if (!cands.length) return;               // Optionswert ohne jede Variante -> wie bisher

    function score(v) {                      // wie viele der uebrigen Zeilen duerfen stehen bleiben
      var o = opts(v), k = 0;
      for (var i = 0; i < sel.length; i++) if (i !== idx && o[i] === sel[i]) k++;
      return k;
    }
    cands.sort(function (a, b) {
      if (a.available !== b.available) return a.available ? -1 : 1;  // kaufbar zuerst
      var s = score(b) - score(a);                                   // moeglichst wenig umstellen
      if (s) return s;
      return a.price - b.price;                                      // sonst die guenstigste
    });

    var po = opts(cands[0]);
    g.forEach(function (grp, i) { if (i !== idx && po[i] != null) apply(grp, po[i]); });
  }, true);

  // Variantenliste im Voraus holen, damit schon der erste Klick sitzt.
  function boot() {
    var p = document.querySelector(PICKER);
    if (p) prefetch(handleOf(p));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
